<div class="filter-for-list">
  <div class="header d-flex justify-content-between">
    <div class="d-flex">
      <h3 class="alarm-project-name">{{projectName}}</h3>
      <div style="float:left">
        <mat-slide-toggle class="sliderActiveList" (change)="reLoadList()" ngModel="activeDevice"
                          placement="right"
                          [ngbTooltip]="'DEVICE_ACTIVE_SLIDER_TOOLTIP' | translate">{{getActiveTextForSlider()}}
        </mat-slide-toggle>
      </div>
    </div>
    <div class="headerButtons">
      <button type="button" placement="bottom"
              [ngbTooltip]="'READ_ICON_TOOLTIP' | translate" class="btn list-tools"
              [routerLink]="'/projects-view/'+idProject">
        <fa-icon [icon]="faEye"></fa-icon>
      </button>
      <button type="button" placement="bottom" style="margin-left: -5px !important;"
              [ngbTooltip]="'UPDATE_ICON_TOOLTIP' | translate" class="btn list-tools"
              [routerLink]="'/projects/'+idProject">
        <fa-icon [icon]="faEdit"></fa-icon>
      </button>
      <button type="button" class="btn top-list-tools" placement="left" ngbTooltip="Click here to add a new item"
              (click)="openModal('create')">
        <fa-icon [icon]="faPlus"></fa-icon>
        {{'ADD_ALARMS'|translate}}
      </button>
    </div>
  </div>
  <div class="">
    <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
      <input matInput value="{{filter}}" (keyup)="applyFilter($event.target.value)"
             [placeholder]="'SEARCH' | translate">
    </mat-form-field>

    <div class="deviceTypeFilter" placement="top"
         [ngbTooltip]="'ALARMS_TYPE_CHIPS' | translate">
      <mat-chip-list>
        <mat-chip *ngFor="let alarmType of alarmTypes index as i "
                  [ngClass]="{'selected' : alarmType.name === selectedAlarmTypeName}"
                  (click)="filterListByAlarmType(alarmType.name)">
          {{alarmType.name | translate}}
        </mat-chip>
      </mat-chip-list>

    </div>
  </div>
  <br clear="both"/>
</div>
<app-progressbar *ngIf="showSpinner===true"></app-progressbar>
<table mat-table [dataSource]="alarmsList" matSort class="table-striped" style="width:100%" matSortActive="id"
       matSortDirection="desc">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</th>
    <td mat-cell *matCellDef="let alarm"> {{alarm.id}}</td>
  </ng-container>
  <ng-container matColumnDef="project">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'PROJECT'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">
      <mat-chip-list>
        <mat-chip>
          {{alarm.project.name}}
        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>
  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'TYPE'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">
      <mat-chip-list>
        <mat-chip style="background: #e91e63;color:#fff">
          {{alarm.type | translate}}
        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'NAME'|translate}}</th>
    <td mat-cell *matCellDef="let alarm"> {{alarm.name}}</td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef style="width:200px;">{{'ACTIONS'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">

      <button type="button" placement="left"
              [ngbTooltip]="'READ_ICON_TOOLTIP' | translate" class="btn list-tools"
              (click)="openModal('read',alarm.id)">
        <fa-icon [icon]="faEye"></fa-icon>
      </button>
      <button type="button" type="button" placement="left"
              [ngbTooltip]="'UPDATE_ICON_TOOLTIP' | translate" class="btn list-tools"
              (click)="openModal('edit',alarm.id)">
        <fa-icon [icon]="faEdit"></fa-icon>
      </button>
      <button style="background: red" type="button" type="button" placement="left"
              [ngbTooltip]="'DELETE_ICON_TOOLTIP' | translate" class="btn list-tools"
              (click)="deleteAlarm(alarm.id)">
        <fa-icon [icon]="faTrash"></fa-icon>
      </button>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="pageSize"></mat-paginator>
